const e = {
  none: "0",
  default: "4px",
  large: "8px",
  focused: "10px",
  rounded: "50px",
  circle: "100%"
};
export {
  e as radius
};
